module.exports = __webpack_public_path__ + "img/powered-by.5837bd37.png";